export { default } from './fbt-subtotal';
